import React, { useCallback } from 'react';
import { ButtonToolbar, DropdownButton, MenuItem } from 'react-bootstrap';
import { xor } from 'lodash';
import { IMPACT_ACTION_PLAN_STATUSES } from '../../lib/schema.js';

ActionPlanStatusFilter.defaultProps = {
  selectedPlanStatuses: [],
};

function ActionPlanStatusFilter({ selectedPlanStatuses, navigateAction }) {
  const selectedCount = selectedPlanStatuses.length;

  const handleSelect = useCallback(
    (actionPlanStatus) =>
      navigateAction({
        actionPlanStatuses: actionPlanStatus
          ? xor(selectedPlanStatuses, [actionPlanStatus])
          : [],
      }),
    [selectedPlanStatuses]
  );

  const renderMenuItem = useCallback(
    (status) => (
      <React.Fragment key={status}>
        <MenuItem
          active={selectedPlanStatuses.includes(status)}
          eventKey={status}
          onSelect={handleSelect}
        >
          {status}
        </MenuItem>
      </React.Fragment>
    ),
    [selectedPlanStatuses]
  );

  return (
    <div className="flex-col report-filter">
      <div className="text-muted filter-label">Action Plan Status</div>
      <ButtonToolbar>
        <DropdownButton
          bsStyle="info"
          title={selectedCount ? `${selectedCount} Selected` : 'All'}
          id="action-plan-status-filter"
          className="btn-block text-capitalize"
          onSelect={handleSelect}
          pullRight
        >
          <MenuItem active={selectedCount === 0}>All</MenuItem>
          <MenuItem divider />
          {IMPACT_ACTION_PLAN_STATUSES.map(renderMenuItem)}
        </DropdownButton>
      </ButtonToolbar>
    </div>
  );
}

export default ActionPlanStatusFilter;
